import type { ReactNode } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import PeopleFilterSelector, {
  type PeopleFilter,
} from './PeopleFilterSelector';

export default function PeopleToolbar({
  actions,
  kind,
  onKindChange,
}: {
  actions?: ReactNode;
  kind?: PeopleFilter;
  onKindChange?: (kind: PeopleFilter) => void;
}) {
  return (
    <Box style={styles.toolbar}>
      {actions ? (
        <Box direction="horizontal" align="center" space="md" wrap>
          {actions}
        </Box>
      ) : null}
      {kind && onKindChange ? (
        <Box style={styles.selector}>
          <PeopleFilterSelector value={kind} onValueChange={onKindChange} />
        </Box>
      ) : null}
    </Box>
  );
}

const styles = StyleSheet.create((theme) => ({
  toolbar: {
    alignItems: {
      base: 'stretch',
      lg: 'center',
    },
    flexDirection: {
      base: 'column',
      lg: 'row',
    },
    gap: theme.space('md'),
    paddingHorizontal: theme.space('lg'),
    paddingVertical: theme.space('md'),
  },
  selector: {
    alignSelf: 'flex-end',
    marginLeft: {
      base: 0,
      lg: 'auto',
    },
  },
}));
